import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import services from '../services';
import { deductionData, collectionPointSchemaObject } from '../../Data'
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
export function CollectionPointAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Collection Point")
    const [groups, setGroups] = useState()

    const [estates, setEstates] = useState()
    const [factories, setfactories] = useState()
    const [collectioncategories, setcollectioncategories] = useState()

    const [collectionpoint, setCollectionPoint] = useState({
        collectionpointID: '',
        groupID: '',
        factoryID: '',
        estateID: '',
        collectionpointName: '',
        collectionpointCode: '',
        collectionpointLocation: '',
        collectionCategoryID: '',
        isActive: true
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    const [labelModel, setLabelModel] = useState({
        Name: "Route Name",
        Code: "Route Code",
        Location: "Route Location",
    })

    const schema = Joi.object(collectionPointSchemaObject).options({ allowUnknown: true })

    // data eka ayin kara
    useEffect(() => {
        if (data && edit) {
            setTitle("Edit Collection Point")
            setCollectionPoint(data)
        } else {
            setTitle("Add Collection Point")
        }
    }, [])

    useEffect(() => {
        getAllGroups()
    }, [])
    useEffect(() => {
        getAllEstates()
    }, [])
    useEffect(() => {
        getAllFactories()
    }, [])
    useEffect(() => {
        getAllCollectionCategories()
    }, [])



    async function getAllGroups() {
        const result = await services.getGroups()

        setGroups(result)
    }

    async function getAllEstates() {
        const result = await services.getEstates()
        setEstates(result)
    }

    async function getAllFactories() {
        const result = await services.getFactories()
        setfactories(result)
    }
    async function getAllCollectionCategories() {
        const result = await services.getCollectionCategories()
        setcollectioncategories(result)
    }

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, collectionPointSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setCollectionPoint({
            ...collectionpoint,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleSave(e) {
        e.preventDefault()

        const errorMessages = validate(schema, collectionpoint)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return

        if (!edit) {
            alert('save');
            const response = await services.saveCollectionPoint(collectionpoint)
            setMessage(false, response.message, response.statusCode)
            ClearModel()
        }
        if (edit) {

            const response = await services.editData(collectionpoint)
            setMessage(false, response.message, response.statusCode)
        }
    }

    function ClearModel() {
        setCollectionPoint({
            ...collectionpoint,
            collectionpointID: '',
            groupID: '',
            factoryID: '',
            estateID: '',
            collectionpointName: '',
            collectionpointCode: '',
            collectionpointLocation: '',
            collectionCategoryID: '',
            isActive: true
        })
    }

    $(function () {
        $("#collectionCategoryID").change(function () {
            var text = $('option:selected', this).text();
            // alert(text);


            //   setLabelModel({ ...labelModel, Name: text + " Name", Code: text + " Code", Location: text + " Location" })


            if (text === 'Route') {
                //    alert('R');
            }
            else {
                // alert($('option:selected', this).text());
            }


        });
    });

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function setMessage(hidden, type, status) {
        setMessageModel({ ...messageModel, hidden: hidden, type: type, disciption: status })
    }


    function renderDropDownGroup(groupList) {
        //alert('inside render');
        // alert(JSON.stringify(groupList));
        let dropDown = groupList === undefined ? null : (
            groupList.map((group) => {
                return (
                    <option value={group.groupID}> {group.groupName} </option>
                );
            }));
        return (
            <select id="groupID" name="groupID" class="form-control mandatory" value={collectionpoint.groupID} onChange={(e) => handleChange(e)} >
                <option value="-1"> Please Select </option>
                {dropDown}
            </select>
        );
    }


    function renderDropDownFatory(factoryList) {
        let dropDown = factoryList === undefined ? null : (
            factoryList.map((factory) => {

                return (
                    <option value={factory.factoryID}> {factory.factoryName} </option>
                );

            }));

        return (
            <select id="factoryID" name="factoryID" class="form-control mandatory" value={collectionpoint.factoryID} onChange={(e) => handleChange(e)} >
                <option value="-1"> Please Select </option>
                {dropDown}
            </select>
        );

    }

    function renderDropDownEstate(EstateList) {
        let dropDown = EstateList === undefined ? null : (
            EstateList.map((estate) => {

                return (
                    <option value={estate.estateID}> {estate.estateName} </option>
                );

            }));

        return (
            <select id="estateID" name="estateID" class="form-control mandatory" value={collectionpoint.estateID} onChange={(e) => handleChange(e)} >
                <option value="-1"> Please Select </option>
                {dropDown}
            </select>
        );

    }

    function renderDropDownCollectionCategory(collectionCategoryList) {
        //  alert(JSON.stringify(collectionCategoryList))
        let dropDown = collectionCategoryList === undefined ? null : (
            collectionCategoryList.map((collectioncategory) => {

                return (
                    <option value={collectioncategory.key}> {collectioncategory.value} </option>
                );

            }));

        return (

            <select id="collectionCategoryID" name="collectionCategoryID" class="form-control mandatory" value={collectionpoint.collectionCategoryID} onChange={(e) => handleChange(e)} >
                <option value="-1"> Please Select </option>
                {dropDown}
            </select>
        );

    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }



    let GroupList = renderDropDownGroup(groups);

    let FactoryList = renderDropDownFatory(factories);

    let EstateList = renderDropDownEstate(estates);

    let CollectionCategoryList = renderDropDownCollectionCategory(collectioncategories);
    return (
        <div>


            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/collectionpoint"
                        />
                    </div>
                    <hr />

                    <div className="row row-top-gap">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Group</label>
                                {GroupList}
                                {errors["groupID"] && <span id="errgroupID" className="text text-danger">{errors["groupID"]}</span>}

                            </div>

                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Factory</label>
                                {FactoryList}

                                {errors["factoryID"] && <span id="errfactoryID" className="text text-danger">{errors["factoryID"]}</span>}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Estate</label>
                                {EstateList}
                                {errors["estateID"] && <span id="errestateID" className="text text-danger">{errors["estateID"]}</span>}

                            </div>
                        </div>
                    </div>


                    <div className="row row-top-gap">

                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Collection Category</label>
                                {CollectionCategoryList}
                                {errors["collectioncategoryID"] && <span id="errcollectioncategoryID" className="text text-danger">{errors["collectioncategoryID"]}</span>}

                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>{labelModel.Name}</label>

                                <input className="form-control mandatory"
                                    name="collectionpointName"
                                    id="collectionpointName"
                                    value={collectionpoint.collectionpointName}
                                    type="text"
                                    onChange={(e) => handleChange(e)} />
                                {errors["routeName"] && <span id="errrouteName" className="text text-danger">{errors["routeName"]}</span>}



                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>{labelModel.Code}</label>
                                <input className="form-control mandatory"
                                    name="collectionpointCode"
                                    id="collectionpointCode"
                                    value={collectionpoint.collectionpointCode}
                                    type="text"
                                    onChange={(e) => handleChange(e)} />
                                {errors["collectionpointCode"] && <span id="errcollectionpointCode" className="text text-danger">{errors["collectionpointCode"]}</span>}


                            </div>
                        </div>
                    </div>



                    <div className="row row-top-gap">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>{labelModel.Location}</label>


                                <input className="form-control mandatory"
                                    name="collectionpointLocation"
                                    id="collectionpointLocation"
                                    value={collectionpoint.collectionpointLocation}
                                    type="text"
                                    onChange={(e) => handleChange(e)} />
                                {errors["collectionpointLocation"] && <span id="errcollectionpointLocation" className="text text-danger">{errors["collectionpointLocation"]}</span>}


                            </div>
                        </div>
                        <div className="col-md-6 pl-1">
                            <div className="form-group">


                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-2">
                            <div className="form-group">

                                <input
                                    disabled={validate(schema, collectionpoint)}
                                    type="submit"
                                    className="btn btn-primary"
                                    value="Save"
                                    onClick={handleSave}
                                />

                                <input type="submit" className="btn btn-warning" value="Cancel" />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">

                            </div>
                        </div>
                        <div className="col-md-8 pl-1">
                            <div className="form-group">&nbsp;</div>
                        </div>
                    </div>

                </div>
            </div>






            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler} OperationTypeList
            />
        </div>
    );
}